import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Formik } from 'formik';
import { getArtisanPublicInquiryAction } from '../../../../modules/inquiries/artisans/public/Actions';
import {
  inquiryByIdSelector,
  artisanPublicInquiriesIsLoadingSelector
} from '../../../../modules/inquiries/artisans/public/Selectors';
import {
  getSinglePendingPublicArtisanInquiryAction,
  moderateCreateArtisanPublicAction,
  updatePendingPublicInquiryAction,
  getPendingPublicInquiriesAction
} from '../../../../modules/artisanModeration/publicInquiry/Actions';
import {
  pendingArtisansPublicInquiryIsLoadingSelector,
  pendingArtisanPublicInquiryByIdSelector
} from '../../../../modules/artisanModeration/publicInquiry/Selectors';

import { InputField, TextArea, Upload } from '../../../../components/form/';

import ModerationForm from '../../../../components/form/ModerationForm';
import getLangData from '../../../../utils/getLangData';

const ViewPublicInquiry = props => {
  const {
    isLoading,
    pendingIsLoading,
    moderateCreateArtisanPublicInquiry,
    inquiryID,
    moderationId,
    inquiry,
    getPublicInquiry,
    updatePendingPublicInquiry,
    getPublicInquiries
  } = props;
  const lang = getLangData().fields
  useEffect(() => {
    // getPublicInquiry(inquiryID);
    getPublicInquiries();
  }, [inquiryID, getPublicInquiry]);

  console.log(inquiry, 'inquiry');
  return (
    <Formik
      enableReinitialize
      initialValues={{ ...inquiry }}
      onSubmit={values => {
        moderateCreateArtisanPublicInquiry(
          {
            id: inquiryID
          },
          values.moderationType
        );
      }}
    >
      {({ handleSubmit }) => (
        <ModerationForm
          handleSubmit={handleSubmit}
          heading={lang.view_pending_public_inquiry}
          isLoading={isLoading || pendingIsLoading}
        >
          {/* <InputField name='customerData[0].firstName' label='Customer First Name' />
          <InputField name='customerData[0].lastName' label='Customer Last Name' />
          <InputField name='artisanCategory.name' label='Category' /> */}
          <InputField name='title' label={lang.title} />

          <TextArea name='message' label={lang.message} />
          {/* <InputField name='attachment' label='attachment' /> */}
          <img src={inquiry?.attachment} className='mb-3' />

          {/* <Upload
            data={{ userID: 'customerId' }}
            name='attachment'
            label='Inquiry Image :'
            S3Bucket='warshatna-users'
            // API="customer/customer-category-image-signedurl/"
            API='users/user-profile-image-signedurl'
          /> */}
        </ModerationForm>
      )}
    </Formik>
  );
};

const mapStateToProps = (state, props) => {
  const inquiryID = props.match.params.id;
  const moderationId = props.match.params.moderationId;
  return {
    inquiryID,
    moderationId,
    inquiry: pendingArtisanPublicInquiryByIdSelector(state, inquiryID),
    // isLoading: artisanPublicInquiriesIsLoadingSelector(state),
    pendingIsLoading: pendingArtisansPublicInquiryIsLoadingSelector(state)
  };
};

const mapDispatchToProps = {
  getPublicInquiry: getSinglePendingPublicArtisanInquiryAction,
  moderateCreateArtisanPublicInquiry: moderateCreateArtisanPublicAction,
  getPublicInquiries: getPendingPublicInquiriesAction
};

export default connect(mapStateToProps, mapDispatchToProps)(ViewPublicInquiry);
